export default __webpack_public_path__ + "static/media/home-mbl.7efd848a.png";